import React, { useState } from "react";
import { connect } from "react-redux";
import DepartmentList from "./DepartmentList";
import CreateNewDepartment from "./CreateNewDepartment";

const Maincontent = () => {
  const [updatelist, setUpdatelist] = useState(true);

  return (
    <>
      <div className="site-layout-background main-frame">
        <CreateNewDepartment
          setUpdatelist={setUpdatelist}
          updatelist={updatelist}
        />
        <DepartmentList updatelist={updatelist} setUpdatelist={setUpdatelist} />
      </div>
    </>
  );
};

export default connect()(Maincontent);
